import { toast } from 'react-toastify';

import React, { useCallback, useState, useEffect } from 'react';

import { useHistory } from 'react-router-dom';

import * as NavigationUtils from '../../utils/navigation';

import { signature } from '../../processes/document';
import * as FileUtils from '../../utils/file.js';

import Document from './Document';
import DocumentDesktop from './DocumentDesktop';
import Header from '../../components/Header';
import Container from '../../components/Container';

import { useWindowDimensions } from "../../utils/windowDimensionSize";
import { usePatientDocumentContext } from '../../contexts/PatientDocument';

function DocumentContainer() {
	const [loading, setLoading] = useState(false);
	const history = useHistory();

	const { document, code } = usePatientDocumentContext();

	useEffect(() => {
		if (document && code) {
			return;
		}

		return NavigationUtils.navigate(history, `/?code=${code}`);
	}, [history, document, code]);

	const onClickSignatureBox = useCallback(() => {
		return NavigationUtils.navigate(history, `/signature?code=${code}`);
	}, [code, history]);

	const submit = useCallback(async () => {
		const documentData = {
			id: document?.id,
			code,
			file: await FileUtils.getBase64Blob(document?.signature_url)
		};

		if (!documentData.file) {
			return toast.warn('A fim de concluir o processo, é necessário assinar o documento.');
		}

		setLoading(true);

		const { data, error } = await signature(documentData);

		setLoading(false);

		if (error) {
			toast.error('Não foi possível assinar o documento, tente novamente em alguns instantes.');
		} else {
			toast.success('Documento assinado com sucesso!');

			document.pdf_url = data?.url;

			NavigationUtils.navigate(history, `/signature-success?code=${code}`);
		}
	}, [code, document, history]);

	const documentTextMarkup = useCallback(() => {
		return {
			__html: document?.text
		};
	}, [document?.text])

	const { width } = useWindowDimensions();

    return (
		<Container>
		{ width >= 600 ? (
			<>
				<Header/>

				<DocumentDesktop
					loading={loading}
					document={document}
					submit={submit}
					onClickSignatureBox={onClickSignatureBox}
					documentTextMarkup={documentTextMarkup}
				/>
			</>
		) : (
			<Document
				loading={loading}
				document={document}
				submit={submit}
				onClickSignatureBox={onClickSignatureBox}
				documentTextMarkup={documentTextMarkup}
			/>
		)}
		</Container>
	);
}

export default DocumentContainer;
